// Barrel for dynamic import
import { parseDocument } from "htmlparser2"
export { Text, Element, ProcessingInstruction } from "domhandler"
import serialize from "dom-serializer"

export { parseDocument, serialize }
